export var ENTITY = "task";
export var REDUCER_KEY = "TASK_V2";
export var BASE_PATH_ENTITY_TASKS = "tasks";
export var BASE_PATH_ENTITY_COMMENTS = "comments";
// Number of comments a task thread shows before "Show more" is pressed.
export var DEFAULT_SHOW_LIMIT = 5;
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY_TASKS,
    requestBodyToUtcWhitelist: ["nextReminderDate"],
};
